import React from 'react'
import Button from '@mui/material/Button'
import GoogleIcon from '@mui/icons-material/Google'
import anearApi from '../Api/AnearApi'
import TokenStorage from '../Api/TokenStorage'

const GoogleOauthButton = ({
  label = 'Continue with Google',
  returnTarget = null,
  sx = {},
}) => {
  const tokenStorage = new TokenStorage()

  const clickHandler = () => {
    tokenStorage.clearOauthReturnTarget()
    if (returnTarget) tokenStorage.setOauthReturnTarget(returnTarget)
    window.location.assign(anearApi.googleOauthUrl())
  }

  return (
    <Button
      fullWidth
      variant="outlined"
      startIcon={<GoogleIcon />}
      onClick={clickHandler}
      sx={{
        mt: 2,
        textTransform: 'none',
        fontWeight: 700,
        borderRadius: 999,
        px: 3,
        py: 1.25,
        fontSize: '1rem',
        color: '#E6E9EF',
        borderColor: 'rgba(230,233,239,0.22)',
        bgcolor: 'rgba(255,255,255,0.03)',
        '&:hover': {
          borderColor: 'rgba(6,182,212,0.6)',
          bgcolor: 'rgba(6,182,212,0.08)',
        },
        ...sx,
      }}
    >
      {label}
    </Button>
  )
}

export default GoogleOauthButton
